import type { IconProps } from "../Icon.props";
import createWebIcon from "../createWebIcon";
import validateKeys from "../validateKeys";

export default function Wheelchair({
  outline = true,
  ...props
}: IconProps): JSX.Element {
  return outline ? (
    <Wheelchair.Outline {...props} />
  ) : (
    <Wheelchair.Solid {...props} />
  );
}

Wheelchair.Outline = function Outline({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Outline`,
    path: (
      <>
        <path
          d="M16.7765 13.2078C16.7743 13.1988 16.7698 13.192 16.7653 13.1853C16.754 13.1583 16.7428 13.1313 16.7293 13.1065C16.718 13.084 16.7068 13.0593 16.6933 13.039C16.6798 13.0188 16.664 12.9985 16.6483 12.9783C16.6303 12.9558 16.6145 12.9333 16.5943 12.913C16.5785 12.8973 16.5605 12.8815 16.5425 12.8658C16.52 12.8455 16.4998 12.8275 16.475 12.8095C16.4548 12.796 16.4345 12.7848 16.4143 12.7713C16.3895 12.7578 16.3648 12.742 16.34 12.7308C16.3175 12.7218 16.295 12.7128 16.2725 12.706C16.2455 12.697 16.2185 12.688 16.1893 12.6813C16.1668 12.6768 16.1443 12.6745 16.1218 12.67C16.0903 12.6655 16.0588 12.661 16.0273 12.661C16.0183 12.661 16.0115 12.6588 16.0048 12.6588H12.4093L11.9255 11.2908H15.0935C15.5458 11.2908 15.9125 10.924 15.9125 10.4718C15.9125 10.0195 15.5458 9.65278 15.0935 9.65278H11.3473L10.6385 7.65028C10.4878 7.22503 10.0198 7.00003 9.59452 7.15078C9.16927 7.30153 8.94427 7.76953 9.09502 8.19478L11.0593 13.7478C11.174 14.074 11.4845 14.2923 11.831 14.2923H15.4198L16.8035 18.286C16.9205 18.6235 17.2378 18.8373 17.5775 18.8373C17.6675 18.8373 17.7575 18.8238 17.8453 18.7923C18.2728 18.6438 18.5 18.178 18.3515 17.7505L16.7765 13.2078Z"
          fill="currentColor"
        />
        <path
          d="M8.10952 4.66228C8.10952 5.54203 8.82277 6.25303 9.70027 6.25303C10.5778 6.25303 11.291 5.53978 11.291 4.66228C11.291 3.78253 10.5778 3.07153 9.70027 3.07153C8.82277 3.07153 8.10952 3.78478 8.10952 4.66228Z"
          fill="currentColor"
        />
        <path
          d="M10.6543 19.6653C8.312 19.6653 6.40625 17.7618 6.40625 15.4173C6.40625 13.6353 7.50875 12.1053 9.0725 11.4753L8.6045 10.15C6.49625 10.9668 5 13.0188 5 15.4173C5 18.5403 7.53125 21.0715 10.6543 21.0715C12.7738 21.0715 14.6188 19.906 15.5885 18.1803L14.8527 16.0653C14.54 18.1015 12.7783 19.6653 10.6543 19.6653Z"
          fill="currentColor"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};

Wheelchair.Solid = function Solid({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Solid`,
    path: (
      <>
        {/**
         * Enter the contents of your SVG here without the <svg> tag.
         * For solid icons, be sure to add `className="icon-primary"`
         * and `className="icon-secondary"` to show the two-tone
         * aspect of the icon if necessary.
         */}
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};
